import { CalendarFiltersType } from "../calendar.types";

const buildDateRangeOverlapClause = (dateRange: { start_date: string; end_date: string }) => {
    const clause = [
        { start_date: { _lte: dateRange.end_date } },
        { end_date: { _gte: dateRange.start_date } },
    ];
    return clause;
};

export const createOverlayScheduleFilter = (calendarFilters: CalendarFiltersType | null) => {
    if (!calendarFilters?.dateRange) return null;

    const filters = {
        _and: [
            ...buildDateRangeOverlapClause(calendarFilters.dateRange),
        ],
    } as any;

    if (calendarFilters.clinic_id && calendarFilters.clinic_id.length > 0) {
        filters._and.push({ clinic_id: { id: { _in: calendarFilters.clinic_id } } });
    }

    if (calendarFilters.technician && calendarFilters.technician.length > 0) {
        filters._and.push({
            user: { technician_id: { id: { _in: calendarFilters.technician } } },
        });
    }

    return filters;
};

export const createOverlayTimeOffFilter = (calendarFilters: CalendarFiltersType | null) => {
    if (!calendarFilters?.dateRange) return null;

    const filters = {
        _and: [
            ...buildDateRangeOverlapClause(calendarFilters.dateRange),
        ],
    } as any;

    if (calendarFilters.clinic_id && calendarFilters.clinic_id.length > 0) {
        filters._and.push({ clinic_id: { id: { _in: calendarFilters.clinic_id } } });
    }

    if (calendarFilters.technician && calendarFilters.technician.length > 0) {
        filters._and.push({
            user: { technician_id: { id: { _in: calendarFilters.technician } } },
        });
    }

    return filters;
};
